// import React, { useEffect, useState } from 'react';

// const RoadmapComponent = () => {
//   const [set, setSet] = useState(0);
//   const [full, setFull] = useState(false);
//   const targetY = window.innerHeight * 0.8;

//   useEffect(() => {
//     const sections = document.querySelectorAll('.section');
//     const timeline = document.querySelector('.timeline');
//     const line = document.querySelector('.line');

//     function scrollHandler() {
//       const scrollY = window.scrollY;
//       const up = scrollY < prevScrollY;
//       const down = !up;

//       const timelineRect = timeline.getBoundingClientRect();
//       const lineRect = line.getBoundingClientRect();

//       const dist = targetY - timelineRect.top;

//       if (down && !full) {
//         setSet(Math.max(set, dist));
//         line.style.bottom = `calc(100% - ${set}px)`;
//       }

//       if (dist > timeline.offsetHeight + 50 && !full) {
//         setFull(true);
//         line.style.bottom = `-50px`;
//       }

//       sections.forEach((item) => {
//         const rect = item.getBoundingClientRect();

//         if (rect.top + item.offsetHeight / 5 < targetY) {
//           item.classList.add('show-me');
//         }
//       });

//       prevScrollY = window.scrollY;
//     }

//     let prevScrollY = window.scrollY;
//     scrollHandler();
//     line.style.display = 'block';
//     window.addEventListener('scroll', scrollHandler);

//     return () => {
//       window.removeEventListener('scroll', scrollHandler);
//     };
//   }, [set, full]);

//   return (
//       <div className="">
//         <div className="Roadmap_text  top-section">
//           <h2 className='pb-2'>Start your Journey Today for a Better Tomorrow</h2>
//           <p className='pb-5'>Embark on your path to a brighter future. Start your journey today, shaping a better tomorrow with endless possibilities.</p>
//         </div>
//         <div className="timeline container">
//           <div className="line"></div>

//           <div className="section">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Professional Training:</h6>
//               <p>Our program offers meticulously curated professional training modules designed to 
//                 equip individuals with the skills and knowledge required in today's competitive landscape. 
//                 From industry-specific expertise to soft skills development, we prioritize comprehensive learning to
//                 ensure readiness for professional challenges.
//               </p>
//             </div>
//           </div>

//           <div className="section d-flex justify-content-end">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Peer Meets:</h6>
//               <p>Our platform fosters a dynamic community where interns can engage in peer-to-peer learning, discussions, and collaborative activities. Networking opportunities within this environment allow individuals to exchange ideas, gain diverse perspectives, and build lasting connections.</p>
//             </div>
//           </div>

//           <div className="section">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Projects:</h6>
//               <p>Engaging in hands-on projects is a pivotal aspect of our internship program. Participants get the chance to apply their learning to real-world scenarios, enabling them to develop practical skills, problem-solving abilities, and a robust portfolio showcasing their accomplishments.</p>
//             </div>
//           </div>

//           <div className="section d-flex justify-content-end">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Certificates:</h6>
//               <p>Upon successful completion of the program, interns receive certificates validating their participation and proficiency in the various aspects of the internship. These certificates serve as a testament to their dedication, effort, and acquired skills throughout the learning journey.</p>
//             </div>
//           </div>

//           <div className="section">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Preparation:</h6>
//               <p>We offer comprehensive guidance and resources to assist interns in preparing for their professional journey. This includes interview preparation, resume building, and skill enhancement sessions tailored to ensure they're equipped to succeed in their careers.</p>
//             </div>
//           </div>

//           <div className="section d-flex justify-content-end">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Interview:</h6>
//               <p>As part of our program, participants receive exclusive guidance and support to excel in interviews. Mock interviews, tips from industry experts, and personalized coaching sessions are provided to enhance confidence and readiness for the job market.</p>
//             </div>
//           </div>

//           <div className="section ">
//             <div className="Road_map_bead"></div>
//             <div className="Road_map_content road_map_text">
//               <h6 className=''>Placement:</h6>
//               <p>Our ultimate goal is to bridge the gap between education and employment. We assist interns in securing placements by leveraging our network of industry partners and providing support throughout the application and placement process.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//   );
// };




import React, { useEffect, useRef, useState } from "react";
import SchoolIcon from '@mui/icons-material/School'; 
import GroupsIcon from '@mui/icons-material/Groups';
import WorkIcon from '@mui/icons-material/Work';
import VerifiedIcon from '@mui/icons-material/Verified'; 
import QuizIcon from '@mui/icons-material/Quiz';  
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';    

const steps = [
  { 
    label: "Register Yourself", 
    description: "Begin your journey by enrolling in your preferred program and unlocking professional learning opportunities.",  
    descriptionStyle: {top: "-210px",color: "#444",width: "250px", }, 
    icon: <SchoolIcon style={{ color: '#4c648ffc', fontSize: '2.5rem', }} />, 
    left: "-1%", 
    top: "130px", 
    direction: "zz-up", 
    lineHeight: "160px", 
    lineBottom: "-70px", 
    labelStyle: { color: '#222222ff',left: "55%", top: "92px", fontWeight: 'bold', userSelect: 'none', }, 
    iconTopOffset: "15px" 
  },
  { 
    label: "Professional Training", 
    description:"Gain real-world skills through expert-led training sessions designed to build your career foundation.",  
    descriptionStyle: {top: "468px",color: "#444",width: "250px", }, 
    icon: <GroupsIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }} />, 
    left: "5.2%", 
    top: "-143px", 
    direction: "zz-down", 
    lineHeight: "160px", 
    lineTop: "250px", 
    labelStyle: { color: '#222',left: "50%", top: "194px", fontWeight: 'bold', textAlign: 'center',   userSelect: 'none', } 
  },
  { 
    label: "Projects", 
    description:"Work on live and practical projects to apply your knowledge and strengthen problem-solving abilities.",  
    descriptionStyle: {top: "-65px",color: "#444",width: "250px", },  
    icon: <WorkIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }}/>, 
    left: "19.5%", 
    top: "85px", 
    direction: "zz-up", 
    lineHeight: "160px", 
    lineBottom: "-210px", 
    labelStyle: { color: '#222',left: "48%", top: "228px", fontWeight: 'bold', userSelect: 'none', }, 
    iconTopOffset: "160px" 
  },
  { 
    label: "Certifications", 
    description:"Earn verified certificates upon successful completion — a mark of your skills and commitment.",  
    descriptionStyle: {top: "465px",color: "#444",width: "250px", }, 
    icon: <VerifiedIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }} />, 
    left: "35%", 
    top: "-145px", 
    direction: "zz-down", 
    lineHeight: "160px",
    labelStyle: { color: '#222', fontWeight: 'bold', top: "218px", userSelect: 'none', },  
    lineTop: "250px" 
  },
  { 
    label: "Skill Development\nTraining", 
    description:"Enhance your resume, communication, and professional skills with targeted development sessions.",  
    descriptionStyle: {top: "-65px",color: "#444",width: "250px", }, 
    icon: <QuizIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }}/>, 
    left: "49%", 
    top: "85px", 
    direction: "zz-up", 
    lineHeight: "160px", 
    lineBottom: "-210px", 
    labelStyle: { color: '#222',left: "78%", top: "240px", fontWeight: 'bold', width: "250px", whiteSpace: 'pre-line', textAlign: 'center',    userSelect: 'none', }, 
    iconTopOffset: "160px" 
  },
  { 
    label: "Mock Interview\nPractice", 
    description:"Prepare with mock interviews, expert feedback, and personalized guidance to build confidence.",  
    descriptionStyle: {top: "465px",color: "#444",width: "250px", }, 
    icon: <AssignmentIndIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }}/>, 
    left: "63.7%", 
    top: "-146px", 
    direction: "zz-down", 
    lineHeight: "160px", 
    lineTop: "250px",
    labelStyle: { color: '#222', fontWeight: 'bold', left: "88%", top: "197px", width: "250px", whiteSpace: 'pre-line', textAlign: 'center', userSelect: 'none', } 
  },
  { 
    label: "Placement Assistance", 
    description:"Get support in securing internships and job opportunities through our network of industry partners.",  
    descriptionStyle: {top: "-65px",color: "#444",width: "250px", }, 
    icon: <HandshakeIcon style={{ color: '#4c648ffc', fontSize: '2.5rem' }}/>, 
    left: "78%", 
    top: "85px", 
    direction: "zz-up", 
    lineHeight: "160px", 
    lineBottom: "-210px", 
    labelStyle: { color: '#222',left: "50%", top: "238px", fontWeight: 'bold',  userSelect: 'none', }, 
    iconTopOffset: "160px" 
  },
  { 
    label: "", 
    icon: <RocketLaunchIcon sx={{ color: '#222222ff', fontSize: 36 }} />, 
    left: "83.5%",
    top: "148px", 
    direction: "zz-down",  
  },
];

export default function RoadmapComponent() {
  const roadmapRef = useRef(null);
  const [animate, setAnimate] = useState(false);
    const [visibleDesc, setVisibleDesc] = useState({}); 
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setAnimate(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (roadmapRef.current) observer.observe(roadmapRef.current);
    return () => observer.disconnect();
  }, []);
  const showDescription = (index) => {
    setVisibleDesc(prev => ({ ...prev, [index]: true }));
    // Hide after 21 seconds
    setTimeout(() => {
      setVisibleDesc(prev => ({ ...prev, [index]: false }));
    }, 21000);
  };

  const roadmapStyles =`
      .Roadmap_text {
         text-align: center;
         margin-bottom: 115px;
      }
      .Roadmap_text h2 { font-size: 2rem; margin-bottom: 10px; color: #21292e; }
      .Roadmap_text p { font-size: 1rem; color: #555; }

      .zz-roadmap-wrap {
        width: 100%;
        padding: 50px 0 30px 0;
        // background: #fff;
      }
      .zz-roadmap-track {
        display: flex;
        align-items: center;
        position: relative;
        margin-left: -50px;
        min-width: 1400px;
        height: 400px;
      }
      .zz-road-svg {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        z-index: 0;
        pointer-events: none;
      }
        
      .zz-step {
        position: relative;
        width: 160px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .zz-bead {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        background: #ecececff; 
        border:  #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        color: #fff;
        box-shadow: 0 2px 5px rgba(0,0,0,0.11);
        z-index: 3;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
        @keyframes revealPath {
        to {
        stroke-dashoffset: 0;
      }
     }
       .reveal-path {
       stroke-dasharray: 28 18;    
       stroke-dashoffset: 4000;     
       animation: revealPath 2.5s ease forwards;
      }
      .zz-step-description {
       position: absolute;
       width: 180px;
       font-size: 0.85rem;
       color: #555;
       text-align: center;
       line-height: 1.4;
       left: 50%;
       transform: translateX(-50%);
      }
      .zz-step-content {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        padding: 0 8px;
        font-size: 0.95rem;
        color: #42556b;
        font-weight: 600;
        z-index: 2;
        display: flex;
        align-items: center;
      }        
      .zz-step.zz-up .zz-step-content {
        bottom: 160px;
      }
      .zz-step.zz-down .zz-step-content {
        top: 220px;
      }
        
      /*  Animations */
      @keyframes growLineFromBottom {
        0% { height: 0; transform-origin: bottom; }
        100% { height: var(--line-height); transform-origin: bottom; }
      }
      @keyframes growLineFromTop {
        0% { height: 0; transform-origin: top; }
        100% { height: var(--line-height); transform-origin: top; }
      }

      @keyframes moveUpWithLine {
        0% { transform: translate(-50%, 0); }
        100% { transform: translate(-50%, calc(-1 * var(--line-height))); }
      }
      @keyframes moveDownWithLine {
        0% { transform: translate(-50%, 0); }
        100% { transform: translate(-50%, var(--line-height)); }
      }
        /* Description moves with icon & line */
        @keyframes descUpWithLine {
          0% { transform: translate(-50%, 0); opacity: 0; }
          100% { transform: translate(-50%, calc(-1 * var(--line-height))); opacity: 1; }
        }
        @keyframes descDownWithLine {
          0% { transform: translate(-50%, 0); opacity: 0; }
          100% { transform: translate(-50%, var(--line-height)); opacity: 1; }
         }
        .desc-up { animation: descUpWithLine 1.4s ease-out forwards; }
        .desc-down { animation: descDownWithLine 1.4s ease-out forwards; }
      
        .line-up { animation: growLineFromBottom 1.4s ease-out forwards; }
        .line-down { animation: growLineFromTop 1.4s ease-out forwards; }
        .bead-up { animation: moveUpWithLine 1.4s ease-out  forwards; }
        .bead-down { animation: moveDownWithLine 1.4s ease-out forwards; }
      `
  return (
    <>    
       <style>{roadmapStyles}</style>
      <div className="zz-roadmap-wrap" ref={roadmapRef}>
         {/* ---------- Heading Text Section ---------- */}
          <div className="Roadmap_text">
             <h2>Start your Journey Today for a Better Tomorrow</h2>
             <p>Embark on your path to a brighter future. Start your journey today, shaping a better tomorrow with endless possibilities.</p>
          </div>
        <div className="zz-roadmap-track">
          <svg className="zz-road-svg" viewBox="0 0 1400 1200" preserveAspectRatio="none">
            <path
              d="M 70 600 Q 150 0, 250 600 Q 350 1200, 470 600 Q 570 0, 670 600 Q 770 1200, 870 600 Q 970 0, 1070 600 Q 1170 1200, 1270 600"
              stroke="#21292e" strokeWidth="22" fill="none"
              className={animate ? "reveal-path" : ""}
              strokeDasharray="28 18"
            />
            <path
              d="M 70 600 Q 150 0, 250 600 Q 350 1200, 470 600 Q 570 0, 670 600 Q 770 1200, 870 600 Q 970 0, 1070 600 Q 1170 1200, 1270 600"
              stroke="#fff" strokeWidth="8" fill="none"
              className={animate ? "reveal-path" : ""}
              strokeDasharray="16 18"
            />
          </svg>
          {steps.map((step, index) => {
            const isUp = index % 2 === 0;
            return (
             <div
               className={`zz-step ${step.direction}`}
               key={step.label}
               style={{
               left: step.left,
               top: step.top,
               position: "absolute",
               }}
            >
         {/* Line */}
           {step.lineHeight && (
            <div
             style={{
              ...(step.lineBottom ? { bottom: step.lineBottom } : {}),
              width: "4px",
              background: "#555",
              position: "absolute",
              top: step.lineTop,
              left: "50%",
              transform: "translateX(-50%)",
              height: step.lineHeight,
              "--line-height": step.lineHeight,
          }}
          className={animate ? (isUp ? "line-up" : "line-down") : ""}
        />
      )}

      {/* Icon moves with line */}
      <div
        className={`zz-bead ${
          animate ? (isUp ? "bead-up" : "bead-down") : ""
        }`}
        style={{
          top: step.lineTop,
          "--line-height": step.lineHeight,
          transform: "translateX(-50%)",
          ...(step.iconTopOffset ? { marginTop: step.iconTopOffset } : {}),
          cursor: "pointer",
         background: "#F5F5F5",
          //background: "#ccc479ff",
         // background: "#bdec94fc",
          //background: "#c2cad8fc",
          //background: "#c2cad8fc",
        }}
        onMouseEnter={() => showDescription(index)}
      >
        {step.icon}
      </div>
      <div
  className="zz-step-content"
  style={{ ...step.labelStyle, userSelect: "none", cursor: "pointer" }} 
  onMouseEnter={() => showDescription(index)} 
>
  {step.label}
</div>


      {/* Description */}
  {step.description && visibleDesc[index] && ( 
  <p
    className="zz-step-description"
    style={{
      position: "absolute",
      width: "220px",
      fontSize: "0.9rem",
      color: "#444",
      textAlign: "center",
      lineHeight: 1.5,
      left: "50%",
      transform: "translateX(-50%)",
      top: step.direction === "zz-down" ? "260px" : undefined,
      bottom: step.direction === "zz-up" ? "200px" : undefined,
      ...step.descriptionStyle,
      userSelect: "none",
      transition: "opacity 0.3s", 
    }}
  >
    {step.description}
  </p>
)}

          </div>
          );
          })}
        </div>
      </div>
    </>
  );
}
